import React from "react";
import { MessageCircle } from "lucide-react";

const Footer = () => {
  return (
    <footer className="border-t border-blue-100 bg-white/60 backdrop-blur">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center">
            <MessageCircle className="w-4 h-4 text-white" strokeWidth={2.5} />
          </div>
          <span className="text-sm font-extrabold text-slate-900">
            Live<span className="text-blue-600">Chat</span>
          </span>
        </div>
        <p className="text-xs sm:text-sm text-slate-500 text-center">
          © {new Date().getFullYear()} LiveChat. All rights reserved.
        </p>
        <div className="flex items-center gap-4 text-xs sm:text-sm text-slate-500">
          <a href="#" className="hover:text-blue-600 transition-colors">
            Privacy
          </a>
          <a href="#" className="hover:text-blue-600 transition-colors">
            Terms
          </a>
          <a href="#" className="hover:text-blue-600 transition-colors">
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
